import { Badge } from "antd";
import { Coins, ImageIcon } from "lucide-react";

interface WalletTabsProps {
	activeTab: string;
	handleTabChange: (tab: string) => void;
	compressedNfts: NFT[];
}

interface MetadataUri {
	name: string;
	image: string;
	publicKey: string;
	owner: string;
	mint: string;
	updateAuthority: string;
}

interface NFT {
	publicKey: string;
	isCompressed: boolean;
	metadata_uri: MetadataUri;
}

export const WalletTabs: React.FC<WalletTabsProps> = ({
	activeTab,
	handleTabChange,
	compressedNfts,
}) => (
	<div
		role="tablist"
		aria-label="Wallet sections"
		className="flex gap-2 md:gap-4 mb-4 flex-wrap"
	>
		<button
			onClick={() => handleTabChange("tokens")}
			id="wallet-tab-tokens"
			aria-controls="wallet-panel-tokens"
			className={`flex items-center gap-1 md:gap-2 px-3 md:px-4 py-2 rounded-lg text-sm ${
				activeTab === "tokens"
					? "bg-[#36C47D] text-[#231F20]"
					: "bg-[#231F20] text-[#918884]"
			}`}
			aria-selected={activeTab === "tokens"}
			role="tab"
		>
			<Coins size={16} />
			Tokens
		</button>
		<button
			onClick={() => handleTabChange("nfts")}
			id="wallet-tab-nfts"
			aria-controls="wallet-panel-nfts"
			className={`flex items-center gap-1 md:gap-2 px-3 md:px-4 py-2 rounded-lg text-sm ${
				activeTab === "nfts"
					? "bg-[#36C47D] text-[#231F20]"
					: "bg-[#231F20] text-[#918884]"
			}`}
			aria-selected={activeTab === "nfts"}
			role="tab"
		>
			<ImageIcon size={16} />
			NFTs
		</button>
		<button
			onClick={() => handleTabChange("cnfts")}
			id="wallet-tab-cnfts"
			aria-controls="wallet-panel-cnfts"
			className={`flex items-center gap-1 md:gap-2 px-3 md:px-4 py-2 rounded-lg text-sm ${
				activeTab === "cnfts"
					? "bg-[#36C47D] text-[#231F20]"
					: "bg-[#231F20] text-[#918884]"
			}`}
			aria-selected={activeTab === "cnfts"}
			role="tab"
		>
			<Badge size="small" />
			cNFTs{" "}
			{compressedNfts.length > 0 && (
				<span className="ml-1 text-xs bg-[#36C47D] text-[#231F20] rounded-full px-1.5">
					{compressedNfts.length}
				</span>
			)}
		</button>
	</div>
);
